import { maybe, rd } from '@passionware/monads';
import { UserCheck } from 'lucide-react';
import type { AppScopeIdentity } from 'v5/core/app-scope/appScope.types';
import { FilterEnumConfig } from 'v5/patterns/filters/FilterWidget.types';
import { MergeServices } from 'v5/platform/ts/services';
import { WithMetastructureMappingService } from 'v5/services/internal/MetastructureMappingService/MetastructureMappingService';
import { WithResourceTypeService } from 'v5/services/internal/ResourceTypeService/ResourceTypeService';
import { WithResourceService } from 'v5/services/io/ResourceService/ResourceService';
import { WithTagService } from 'v5/services/io/TagsService/TagsService';
import { WithGroupsService } from 'v5/services/io/GroupsService/GroupsService';

export function createResourceTypeFilterConfig(
  services: MergeServices<
    [
      WithMetastructureMappingService,
      WithResourceTypeService,
      WithResourceService,
      WithTagService,
      WithGroupsService
    ]
  >,
  scope: AppScopeIdentity
): FilterEnumConfig<number> {
  const useResourceTypeOptions = (query: string) => {
    const resourceTypes = services.resourceTypeService.useResourceTypes(
      maybe.of(scope)
    );
    return rd.map(resourceTypes, resourceTypes => {
      const displayValues = resourceTypes.map(resourceType => ({
        value: resourceType.id,
        label: resourceType.name ?? '(no name)'
      }));
      const normalizedQuery = query.trim().toLowerCase();
      const filtered = displayValues.filter(d =>
        d.label.toLowerCase().includes(normalizedQuery)
      );
      return filtered;
    });
  };

  const useResourceTypeValues = (values: number[]) => {
    const resourceTypes = services.resourceTypeService.useResourceTypes(
      maybe.of(scope)
    );
    return rd.map(resourceTypes, resourceTypes => {
      return resourceTypes
        .filter(resourceType => values.includes(resourceType.id))
        .map(resourceType => ({
          value: resourceType.id,
          label: resourceType.name ?? '(no name)'
        }));
    });
  };

  return {
    label: 'Type', // todo this needs i18n hook for proper translation
    icon: <UserCheck />,
    type: 'enum',
    createDefaultValue: () => ({ operator: 'matchAny', value: [] as number[] }),
    options: {
      useValues: useResourceTypeValues,
      useOptions: useResourceTypeOptions
    }
  };
}
